import Vue from 'vue';
import workerloanCalculator from './workerloan-calculator/workerloan-calculator.vue';
Vue.component('workerloan-calculator', workerloanCalculator);
